module.exports = __webpack_public_path__ + "static/media/5start.b065a474.png";